import { ReactNode } from "react";

import { TypographyProps } from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import Box from "ds/components/Box";

import Typography from "../../Typography";
import styles from "./styles.module.css";

type ActionCardTitleProps = {
  children: React.ReactNode;
  variant?: TypographyProps["variant"];
  suffix?: ReactNode;
};

const ActionCardTitle = ({ children, variant, suffix }: ActionCardTitleProps) => {
  return (
    <Box align="center" className={styles.titleWrapper}>
      <TextEllipsis tooltip={children} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Typography {...props} tag="span" className={styles.title} variant={variant}>
            {children}
          </Typography>
        )}
      </TextEllipsis>
      {suffix}
    </Box>
  );
};

ActionCardTitle.displayName = "DS.ActionCard.Title";

export default ActionCardTitle;
